// PDF → immagini delle pagine, nel browser (pdf.js da public/pdfjs, caricato solo quando serve).
// Le pagine poi seguono la stessa strada delle pagine immagine del regolamento.
const LATO = 1800;

export const apriPdf = async (file) => {
  const pdfjs = await import(/* webpackIgnore: true */ '/pdfjs/pdf.min.js');
  pdfjs.GlobalWorkerOptions.workerSrc = '/pdfjs/pdf.worker.min.js';
  try {
    return await pdfjs.getDocument({ data: await file.arrayBuffer(), isEvalSupported: false, enableScripting: false }).promise;
  } catch (e) {
    throw new Error(e?.name === 'PasswordException' ? 'Il PDF è protetto da password: toglila e riprova' : 'Questo PDF non si riesce ad aprire');
  }
};

export const paginaPdf = async (doc, n) => {
  const pagina = await doc.getPage(n);
  const base = pagina.getViewport({ scale: 1 });
  const viewport = pagina.getViewport({ scale: LATO / Math.max(base.width, base.height) });
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(viewport.width); canvas.height = Math.round(viewport.height);
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, canvas.width, canvas.height);
  await pagina.render({ canvas, canvasContext: ctx, viewport }).promise;
  pagina.cleanup();
  return new Promise((ok, ko) => canvas.toBlob(b => (b ? ok(b) : ko(new Error('Pagina non convertita'))), 'image/png'));
};

export const chiudiPdf = (doc) => { try { doc?.loadingTask?.destroy(); } catch { /* già chiuso */ } };
